// extracted by mini-css-extract-plugin
export var compact = "_mr-2";
export var phoneFrame = "_mr-0";
export var phoneScreen = "_mr-1";